<template>
  <tr :class="{'clickable': $can('edit', 'CurrencyExchangeMarginRate')}">
    <td>
      {{ currencyExchangeMarginRate.years_in_future }}
    </td>
    <td>
      {{ currencyExchangeMarginRate.rate | percentage(4) }}
    </td>
  </tr>
</template>

<script>
  export default {
    name: 'CurrencyExchangeMarginRateRow',
    props: {
      currencyExchangeMarginRate: {
        type: Object,
        default: null
      }
    }
  }
</script>
